/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// Packages
import React from 'react'
import ApolloClient, { gql } from 'apollo-boost'
import _lang from 'lodash/lang'
import _ from 'lodash'
import moment from 'moment'
// Styles
import { message } from 'antd'

const Client = new ApolloClient({
	uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
	headers: {
		'X-Hasura-Admin-Secret': process.env.REACT_APP_HASURA_SECRET,
	},
})

const initCreateJob = async (
	setCurrentUserCompanies,
	setCurrentUserBranches,
	setMrtStationsList,
	setCities,
	setJobCategories,
	setJobSpecialization,
	setJobPostEndDate,
	setJobEvents,
	setHashtags,
	setRenderReady,
	setInitialValues,
	// setAreICMSRequired,
	setPlatform
) => {
	const getDataQuery = gql`{
      Company(where: {
        isActive: {_eq: true}
        User: {UserPlatforms: {platform: {_in: ["REGULAR", "VCF", "NTUC", "WESTCOAST"]}}}
      }) {
        id
        name
        createdAt
        User {
          name
          email
          country
          # isRequiredICMS
          # ONLY ADMIN role
          UserPlatforms {
            platform
          }
        }
        Branches(where: {isActive: {_eq: true}} order_by: {name: asc}) {
          id
          name
          Address {
            streetAddress
            unit
            postalCode
          }
        }
      }
     
      MrtStation(order_by: {mrtLine:asc name: asc}){
        id name
        MrtLine { colour}
      }
 
      City(order_by: {
        State: {name: asc}
        name: asc
      }) {
        id name
        State { name}
      }
    
      Occupation(order_by: {sequence: asc}) {
        id
        name
      }
      Category(order_by: {name: asc}) {
        id
        name
      }
      Event(where: {_or: [
        {id: {_eq: 74}},
        {endDate: {_gt:"${new Date(Date.now()).toISOString()}"}}
      ]}) {
        id
        name
        endDate
        jobGroupType
      }
      Hashtag {
        hashtag
        description
      }
    }
    `

	return Client.query({
		query: getDataQuery,
	})
		.then((cucRes) => {
			// Setting the Company Data
			const {
				data: {
					Company,
					MrtStation,
					Occupation,
					Event,
					Hashtag,
					Category,
					User_by_pk: user,
					City,
				},
			} = cucRes
			if (Event && Event.length) {
				setJobEvents(Event)
			}

			if (Category && Category.length) {
				setJobSpecialization(Category)
			}
			if (Company && Company.length) {
				// For Checkbox
				const companyOptions = Company.map((com) => {
					return {
						value: com.id,
						label: com.name,
					}
				})
				setCurrentUserCompanies(companyOptions)
			}

			setHashtags(Hashtag)
			// if (Company && Company.length > 5) {
			//   // For Mulitple Selection
			//   const companyOptions = Company.map((com) => {
			//     return (
			//       <Option key={com.id} value={com.name}>{com.name}</Option>
			//     )
			//   })
			//   setCurrentUserCompanies(companyOptions)
			// }
			// Setting the Branch Data
			if (Company && Company.length) {
				const branches = Company.map((com) => {
					const user = com.User

					const getPlatform = () => {
						const userPlatforms = user.UserPlatforms

						if (userPlatforms.some((ele) => ele.platform === 'NTUC'))
							return 'NTUC'
						else if (userPlatforms.some((ele) => ele.platform === 'WESTCOAST'))
							return 'WESTCOAST'
						else return 'REGULAR'
					}

					return {
						companyId: com.id,
						companyName: com.name,
						companyUserName: user ? user.name : '',
						companyUserEmail: user ? user.email : '',
						companyUserCountry: user ? user.country : null,
						createdAt: com.createdAt,
						branches: com.Branches,
						selectedBranches: [],
						selectedMrtStations: [],
						selectedCities: [],
						// isRequiredICMS: user && user.isRequiredICMS ? user.isRequiredICMS : false,
						// isRequiredICMS: user.UserPlatforms.length > 0 ? userPlatforms.some(ele => ele.platform === 'NTUC') : false,
						platform:
              user && user.UserPlatforms && user.UserPlatforms.length > 0
              	? getPlatform()
              	: '',
						// Mainly used for checkbox
						branchOptions: com.Branches.map((b) => {
							// Check for null unit
							if (b.Address.unit) {
								b.Address.unit = b.Address.unit + ', '
							} else {
								b.Address.unit = ''
							}
							return {
								value: b.id,
								label:
                  b.name +
                  ' - ' +
                  b.Address.streetAddress +
                  ', ' +
                  b.Address.unit +
                  b.Address.postalCode,
							}
						}),
					}
				})
				setCurrentUserBranches(branches)
			}
			// Set MRT Stations List
			if (MrtStation && MrtStation.length > 0) {
				setMrtStationsList(MrtStation)
			}
			if (City && City.length > 0) setCities(City)

			// Store Occupation's table data in state for Dropdown ...
			if (Occupation.length) {
				setJobCategories(Occupation)
			}

			// Employers' role
			if (user !== undefined) {
				// const { isRequiredICMS } = user // Boolean || null
				// if (isRequiredICMS !== null && isRequiredICMS) {
				//   setAreICMSRequired(true)
				// } else setAreICMSRequired(false)

				const userPlatforms = user.UserPlatforms

				if (userPlatforms.some((ele) => ele.platform === 'NTUC'))
					setPlatform('NTUC')
				else if (userPlatforms.some((ele) => ele.platform === 'WESTCOAST'))
					setPlatform('WESTCOAST')
				else setPlatform('REGULAR')
			}

			setInitialValues({
				jobPostDate: [moment(moment(), 'DD/MM/YYYY')],
			})
		})
		.catch((deleteErr) => {
			console.error(deleteErr, 'deleteErr')
		})
}

const initEditJob = async (
	jobId,
	companyId,
	setCurrentUserCompanies,
	setIsJobType,
	setBranchIds,
	setMRTStationIds,
	setCityIds,
	setWorkingLocations,
	setCurrentUserBranches,
	setJobSalaries,
	setIsEmploymentType,
	setJobPostEndDate,
	setInitialValues,
	setIsOtherSelected,
	setMrtStationsList,
	setCities,
	setJobCategories,
	setJobSpecialization,
	setJobEvents,
	setHashtags,
	setCurrentHashtags,
	setRenderReady,
	setFormInitialValue,
	setJobQuestion,
	setHaveQuestion,
	setCurrentJobQuestion,
	setPlatform
) => {
	const getDataQuery = gql`
    query ($jobId: Int, $companyId: Int) {
      Job(where: {id: {_eq: $jobId}}) {
        description
        descriptionChinese
        descriptionMalay
        jobPostEnd
        jobPostStart
        jobPostType
        requirements
        requirementsChinese
        requirementsMalay
        title
        titleChinese
        titleMalay
        jobOccupation
        jobOccupationOthers
        eventID
        jobCategory
        minimumEducation
        Company {
          id
          name
        }
        # Fill up checkbox (WorkLocation of Job)
        JobLocations {
          id
          mrtStation
          cityId
          Branch {
            id
            name
            Address {
              postalCode
              streetAddress
              unit
            }
          }
        }
        JobSalaries {
          id
          jobType
          max
          min
          salaryType
        }
        JobHashTags {
          id
          hashtag
        }
        JobQuestions(order_by: {sequence: asc}, where: {deletedAt: {_is_null: true}}) {
          id
          sequence
          Question {
            Answers(order_by: {sequence: asc}) {
              id
              answer
              answerChinese
              answerMalay
              sequence
            }
            id
            questionChinese
            questionMalay
            question
            questionType
            isTemplate
            maxAnswer
          }
        }
      }
      # List ALL JobLocations associated with the Company that posted this Job ...
      Company(where: {isActive: {_eq: true}, _and: {id: {_eq: $companyId}}}) {
        id
        name
        createdAt
        Branches(where: {isActive: {_eq: true}} order_by: {name: asc}) {
          id
          name
          Address {
            streetAddress
            unit
            postalCode
          }
        }
        User {
          UserPlatforms {
            platform
          }
		  country
        }
      }
  
      MrtStation(order_by: {mrtLine:asc name: asc}){
        id name
        MrtLine { colour}
      }

      City(order_by: {
        State: {name: asc}
        name: asc
      }) {
        id name
        State { name}
      }
    
      Occupation(order_by: {sequence: asc}) {
        id
        name
      }
      Category(order_by: {name: asc}) {
        id
        name
      }
      Event(where: {_or: [
        {id: {_eq: 74}},
        {endDate: {_gt:"${new Date(Date.now()).toISOString()}"}}
      ]}) {
        id
        name
        endDate
        jobGroupType
      }
      Hashtag {
        hashtag
        description
      }
    }
    `

	return Client.query({
		query: getDataQuery,
		variables: {
			jobId: jobId,
			companyId: companyId,
		},
	})
		.then((cucRes) => {
			// Setting the Company Data
			const {
				data: {
					Company,
					Job,
					MrtStation,
					Occupation,
					Event,
					Hashtag,
					Category,
					User_by_pk: user,
					City,
				},
			} = cucRes
			setJobQuestion(
				Job[0].JobQuestions.map((jq) => {
					return jq.Question
				})
			)
			setCurrentJobQuestion(
				Job[0].JobQuestions.map((jq) => {
					return jq.id
				})
			)
			setHaveQuestion(Job[0].JobQuestions.length > 0)
			if (Event && Event.length) {
				setJobEvents(Event)
			}

			if (Category && Category.length) {
				setJobSpecialization(Category)
			}

			if (Company.length) {
				// Used once in mutation obj ...
				const companyOptions = Company.map((com) => {
					return {
						value: com.id,
						label: com.name,
					}
				})
				setCurrentUserCompanies(companyOptions)

				setHashtags(Hashtag)
				setCurrentHashtags(Job[0].JobHashTags)

				// for the Job Language
				const jobTypeObj = (jobPostType) => {
					if (jobPostType === 'ENCN') return { en: true, cn: true }
					else if (jobPostType === 'EN') return { en: true }
					else if (jobPostType === 'CN') return { cn: true }
					else if (jobPostType === 'MY') return { my: true }
					else if (jobPostType === 'ENCNMY')
						return { en: true, cn: true, my: true }
					else if (jobPostType === 'ENMY') return { en: true, my: true }
					else if (jobPostType === 'CNMY') return { cn: true, my: true }
				}
				setIsJobType(jobTypeObj(Job[0].jobPostType))

				// for storing Job's Working Location(s)
				const { JobLocations } = Job[0]

				const branchIdsArr = JobLocations.filter(
					(location) => location.Branch
				).map((location) => location.Branch.id)

				const mrtStationIdsArr = JobLocations.filter(
					(location) => location.mrtStation
				).map((location) => location.mrtStation)

				setBranchIds(branchIdsArr)
				setMRTStationIds(mrtStationIdsArr)
				setCityIds(
					JobLocations.filter((location) => location.cityId !== null).map(
						(location) => location.cityId
					)
				)

				// Store the jobLocations somewhere for comparing later...
				// Can use for branch and mrtStation ?
				setWorkingLocations(JobLocations)

				const branches = Company.map((com) => {
					const user = com.User

					const getPlatform = () => {
						const userPlatforms = user.UserPlatforms

						if (userPlatforms.some((ele) => ele.platform === 'NTUC'))
							return 'NTUC'
						else if (userPlatforms.some((ele) => ele.platform === 'WESTCOAST'))
							return 'WESTCOAST'
						else return 'REGULAR'
					}

					return {
						companyId: com.id,
						companyName: com.name,
						createdAt: com.createdAt,
						branches: com.Branches,
						companyUserCountry: user ? user.country : null,
						platform:
              user !== undefined &&
              user.UserPlatforms !== undefined &&
              user.UserPlatforms.length > 0
              	? getPlatform()
              	: '',
						selectedBranches: JobLocations.length
							? JobLocations.filter((location) => location.Branch !== null).map(
								(location) => location.Branch.id
							)
							: [],
						selectedMrtStations: JobLocations.length
							? JobLocations.filter((jl) => jl.mrtStation !== null).map(
								(jl) => jl.mrtStation
							)
							: [],
						selectedCities: JobLocations.length
							? JobLocations.filter((location) => location.cityId !== null).map(
								(location) => location.cityId
							)
							: [],
						branchOptions: com.Branches.map((b) => {
							// Check for null unit
							if (b.Address.unit) {
								b.Address.unit = b.Address.unit + ', '
							} else {
								b.Address.unit = ''
							}
							return {
								value: b.id,
								label:
                  b.name +
                  ' - ' +
                  b.Address.streetAddress +
                  ', ' +
                  b.Address.unit +
                  b.Address.postalCode,
							}
						}),
					}
				})
				setCurrentUserBranches(branches)
			}
			// Set the Job Data
			if (!_lang.isEmpty(Job)) {
				const { JobSalaries } = Job[0] // [{id, jobType, max, min, salaryType}]
				setJobSalaries(JobSalaries)
				const employmentTypeObj = {}
				JobSalaries.forEach((Salary) => {
					if (Salary.jobType === 'FT') {
						employmentTypeObj.FT = true
					} else if (Salary.jobType === 'PT') {
						employmentTypeObj.PT = true
					} else if (Salary.jobType === 'CONTRACT') {
						employmentTypeObj.CONTRACT = true
					}
				})
				setIsEmploymentType(employmentTypeObj)

				// returns undefine if condition not met
				const JobSalaryFT = JobSalaries.find((js) => {
					return js.jobType === 'FT'
				})
				const JobSalaryPT = JobSalaries.find((js) => {
					return js.jobType === 'PT'
				})
				const JobSalaryContract = JobSalaries.find((js) => {
					return js.jobType === 'CONTRACT'
				})
				const jobPostStartDate = Job[0].jobPostStart
					? moment(Job[0].jobPostStart).utc().format('DD-MM-YYYY')
					: moment().utc().format('DD-MM-YYYY')
				// const jobPostEndDate = Job[0].jobPostEnd ? moment(Job[0].jobPostEnd).utc().format('DD-MM-YYYY') : moment().add(1, 'month').utc().format('DD-MM-YYYY')
				// console.log(Job)
				// check if object is not empty ...
				const employmentType = []
				if (
					Job[0].JobSalaries.filter((js) => {
						return js.jobType === 'FT'
					}).length > 0
				) {
					employmentType.push('ft')
				}
				if (
					Job[0].JobSalaries.filter((js) => {
						return js.jobType === 'PT'
					}).length > 0
				) {
					employmentType.push('pt')
				}
				if (
					Job[0].JobSalaries.filter((js) => {
						return js.jobType === 'CONTRACT'
					}).length > 0
				) {
					employmentType.push('contract')
				}
				const jobType = []
				if (Job[0].jobPostType.indexOf('EN') !== -1) {
					jobType.push('en')
				}
				if (Job[0].jobPostType.indexOf('CN') !== -1) {
					jobType.push('cn')
				}
				if (Job[0].jobPostType.indexOf('MY') !== -1) {
					jobType.push('my')
				}

				const initValues = {
					minimumEducation: Job[0].minimumEducation,
					title: Job[0].title,
					description: Job[0].description,
					requirements: Job[0].requirements,
					titleCn: Job[0].titleChinese,
					descriptionCn: Job[0].descriptionChinese,
					requirementsCn: Job[0].requirementsChinese,
					titleMy: Job[0].titleMalay,
					descriptionMy: Job[0].descriptionMalay,
					requirementsMy: Job[0].requirementsMalay,
					jobType: jobType,
					event: Job[0].eventID,
					specialization: Job[0].jobCategory,
					jobPostDate: [moment(jobPostStartDate, 'DD/MM/YYYY')],
					jobPostEndDate: Job[0].jobPostEnd ? moment(Job[0].jobPostEnd) : null,
					employmentType: employmentType,
					...(!_lang.isEmpty(JobSalaryFT) && {
						minSalaryFT:
              JobSalaryFT.min !== null ? JobSalaryFT.min.toString() : null,
						maxSalaryFT:
              JobSalaryFT.max !== null ? JobSalaryFT.max.toString() : null,
						salaryTypeFT: JobSalaryFT.salaryType || 'PER MONTH',
					}),
					...(!_lang.isEmpty(JobSalaryPT) && {
						minSalaryPT:
              JobSalaryPT.min !== null ? JobSalaryPT.min.toString() : null,
						maxSalaryPT:
              JobSalaryPT.max !== null ? JobSalaryPT.max.toString() : null,
						salaryTypePT: JobSalaryPT.salaryType || 'PER HOUR',
					}),
					...(!_lang.isEmpty(JobSalaryContract) && {
						minSalaryContract:
              JobSalaryContract.min !== null
              	? JobSalaryContract.min.toString()
              	: null,
						maxSalaryContract:
              JobSalaryContract.max !== null
              	? JobSalaryContract.max.toString()
              	: null,
						salaryTypeContract: JobSalaryContract.salaryType || 'PER MONTH',
					}),
					category: Job[0].jobOccupation,
					categoryText: Job[0].jobOccupationOthers,
					salaryTypeFT: 'PER MONTH',
					selectedCompany: Job[0].Company,
				}

				initValues.hashtags = Job[0].JobHashTags.map((jht) => {
					return jht.hashtag
				})
				setInitialValues(initValues)
				if (Job[0].jobOccupation === 9999) setIsOtherSelected(true)
			}

			if (MrtStation && MrtStation.length > 0) {
				setMrtStationsList(MrtStation)
			}
			if (City && City.length > 0) setCities(City)

			if (Occupation.length) {
				setJobCategories(Occupation)
			}

			if (user !== undefined) {
				const userPlatforms = user.UserPlatforms

				if (userPlatforms.some((ele) => ele.platform === 'NTUC'))
					setPlatform('NTUC')
				else if (userPlatforms.some((ele) => ele.platform === 'WESTCOAST'))
					setPlatform('WESTCOAST')
				else setPlatform('REGULAR')
			}
		})
		.catch((deleteErr) => {
			console.error(deleteErr, 'deleteErr')
		})
}

const handleOnSubmitCreate = (
	values,
	selectedCompany,
	currentUserBranches,
	jobEvents,
	jobQuestion,
	haveQuestion,
	navigate
) => {
	let jobQuestionObjects = {}
	if (haveQuestion) {
		jobQuestionObjects = jobQuestion.map((jq, i) => {
			const tempQuestionObj = {
				question: jq.question,
				questionChinese: jq.questionChinese,
				questionMalay: jq.questionMalay,
				isTemplate: jq.isTemplate,
				questionType: jq.questionType,
			}
			if (jq.questionType === 'MCQ') {
				tempQuestionObj.maxAnswer = jq.maxAnswer
			}
			if (jq.questionType !== 'OPENENDED') {
				tempQuestionObj.Answers = {
					data: jq.Answers.map((ja) => {
						return {
							answer: ja.answer,
							answerChinese: ja.answerChinese,
							answerMalay: ja.answerMalay,
							sequence: ja.sequence,
						}
					}),
				}
			}
			if (jq.isTemplate && jq.id) {
				return {
					question: jq.id,
					sequence: i + 1,
				}
			} else {
				return {
					Question: {
						data: tempQuestionObj,
					},
					sequence: i + 1,
				}
			}
		})
	}

	// Check if branch or mrt/city selected for each company
	const checkBranchOrMrtOrCitySelected = selectedCompany?.length
		? selectedCompany.every((company) => {
			let allOk = false
			if (company.companyUserCountry === 'SG') {
				if (
					(company.selectedBranches && company.selectedBranches.length > 0) ||
            (company.selectedMrtStations &&
              company.selectedMrtStations.length > 0)
				)
					allOk = true
				else allOk = false
			} else if (company.companyUserCountry === 'MY') {
				if (
					(company.selectedBranches && company.selectedBranches.length > 0) ||
            (company.selectedCities && company.selectedCities.length > 0)
				)
					allOk = true
				else allOk = false
			}
			return allOk
		})
		: false

	if (checkBranchOrMrtOrCitySelected) {
		const jobSalaryObj = () => {
			try {
				const jobSalaryArr = []
				if (values.employmentType.indexOf('ft') !== -1) {
					const eachJsObj = {
						min: parseInt(values.minSalaryFT),
						max: parseInt(values.maxSalaryFT),
						jobType: 'FT',
						// salaryType: values.salaryTypeFT
						salaryType: 'PER MONTH',
					}
					jobSalaryArr.push(eachJsObj)
				}
				if (values.employmentType.indexOf('pt') !== -1) {
					const eachJsObj = {
						min: parseInt(values.minSalaryPT),
						max: parseInt(values.maxSalaryPT),
						jobType: 'PT',
						salaryType: values.salaryTypePT,
					}
					jobSalaryArr.push(eachJsObj)
				}
				if (values.employmentType.indexOf('contract') !== -1) {
					const eachJsObj = {
						min: parseInt(values.minSalaryContract),
						max: parseInt(values.maxSalaryContract),
						jobType: 'CONTRACT',
						salaryType: values.salaryTypeContract,
					}
					jobSalaryArr.push(eachJsObj)
				}
				return jobSalaryArr
			} catch (error) {
				console.error(error, 'error-jobSalaryObj')
			}
		}

		// Job Location Object
		const jobLocationObj = (company) => {
			// An company id is passed in
			try {
				// Find current company selected branches
				// return undefined?
				const currentCompany = currentUserBranches.find((c) => {
					return company.companyId === c.companyId
				})
				// return only branches according to job location object
				const branches = currentCompany.selectedBranches?.length
					? currentCompany.selectedBranches.map((branch) => {
						return {
							branch,
						}
					})
					: []

				// return only mrtStation according to job location object
				if (currentCompany?.companyUserCountry === 'SG') {
					const mrtStations = currentCompany.selectedMrtStations?.length
						? currentCompany.selectedMrtStations.map((mrtStation) => {
							return {
								mrtStation,
							}
						})
						: []

					return branches.concat(mrtStations)
				} else if (currentCompany?.companyUserCountry === 'MY') {
					const cities = currentCompany.selectedCities?.length
						? currentCompany.selectedCities.map((cityId) => {
							return { cityId }
						})
						: []

					return branches.concat(cities)
				}
			} catch (error) {
				console.error(error, 'error-jobLocationObj')
			}
		}

		if (typeof values.hashtags !== 'undefined') {
			values.hashtags = values.hashtags.map((ht) => {
				const tempObj = {
					hashtag: ht,
				}
				return tempObj
			})
		}
		// eslint-disable-next-line
    const jobObjects = selectedCompany.map((company) => {
			const tempObj = {
				companyId: company.companyId,
				jobPostStart: moment().format(),
				jobPostEnd:
          values.jobPostEndDate !== ''
          	? values.jobPostEndDate.format() || null
          	: null,
				jobPostType: '',
				JobSalaries: { data: jobSalaryObj() },
				JobLocations: { data: jobLocationObj(company) },
				jobOccupation: values.category,
				jobOccupationOthers: values.categoryText ? values.categoryText : null,
				isAvailable: !values.event,
				country: company.companyUserCountry ?? null,
				minimumEducation: values.minimumEducation
					? values.minimumEducation
					: null,
			}

			if (values.specialization) {
				tempObj.jobCategory = values.specialization
			}

			tempObj.eventID =
        typeof values.event !== 'undefined' ? values.event : null
			tempObj.JobHashTags =
        values.hashtags !== undefined && values.hashtags.length
        	? { data: values.hashtags }
        	: null

			if (tempObj.eventID) {
				const selectedEvent = jobEvents.filter(
					(je) => parseInt(tempObj.eventID) === je.id
				)
				if (selectedEvent.length > 0) {
					tempObj.jobPostEnd = selectedEvent[0].endDate
					tempObj.jobGroupType = selectedEvent[0].jobGroupType
				}

				tempObj.JobPlatforms = { data: { platform: 'VCF' } }
			} else {
				if (company.platform === 'NTUC') {
					tempObj.JobPlatforms = {
						data: [{ platform: company.platform }, { platform: 'REGULAR' }],
					}
				} else tempObj.JobPlatforms = { data: { platform: company.platform } }
			}

			tempObj.isRequiredICMS = company.platform === 'NTUC'

			if (values.jobType.indexOf('en') !== -1) {
				tempObj.title = values.title
				tempObj.description = values.description
				tempObj.requirements = values.requirements
				tempObj.jobPostType += 'EN'
			}

			if (values.jobType.indexOf('cn') !== -1) {
				tempObj.titleChinese = values.titleCn
				tempObj.descriptionChinese = values.descriptionCn
				tempObj.requirementsChinese = values.requirementsCn
				if (tempObj.jobPostType === '') {
					tempObj.title = values.titleCn
					tempObj.description = values.descriptionCn
					tempObj.requirements = values.requirementsCn
				}
				tempObj.jobPostType += 'CN'
			}

			if (values.jobType.indexOf('my') !== -1) {
				tempObj.titleMalay = values.titleMy
				tempObj.descriptionMalay = values.descriptionMy
				tempObj.requirementsMalay = values.requirementsMy
				if (tempObj.jobPostType === '') {
					tempObj.title = values.titleMy
					tempObj.description = values.descriptionMy
					tempObj.requirements = values.requirementsMy
				}
				tempObj.jobPostType += 'MY'
			}

			if (haveQuestion) {
				tempObj.JobQuestions = {
					data: jobQuestionObjects,
				}
			}
			return tempObj
		})

		// console.log(jobObjects)

		// ********** Mutate a new Job **********
		Client.mutate({
			mutation: gql`
        mutation ($jobObjects: [Job_insert_input!]!) {
          insert_Job(objects: $jobObjects) {
            affected_rows
          }
        }
      `,
			variables: {
				jobObjects: jobObjects,
			},
		})
			.then((jobMutationRes) => {
        const { data } = jobMutationRes; // eslint-disable-line
				const affectedRows = data.insert_Job.affected_rows
				if (affectedRows) {
          // eslint-disable-line
					navigate(-1)
					message.success(
						`${
							selectedCompany.length > 1
								? selectedCompany.length + ' jobs'
								: selectedCompany.length + ' job created'
						}`
					)
				}
			})
			.catch((deleteErr) => {
				console.error(deleteErr, 'deleteErr')
			})
	} else {
		message.warning(
			'Please select at least one branch and/or MRT Station/City as the working location for each company selected'
		)
	}
}

const handleOnSubmitUpdate = (
	values,
	selectedCompany,
	currentUserBranches,
	mrtStationsList,
	cities,
	jobId,
	companyId,
	jobSalaries,
	isEmploymentType,
	branchIds,
	mrtStationIds,
	cityIds,
	workingLocations,
	currentHashtags,
	jobEvents,
	jobQuestion,
	currentJobQuestion,
	haveQuestion,
	navigate
) => {
	let jobQuestionObjects = {}
	if (haveQuestion) {
		jobQuestionObjects = jobQuestion.map((jq, i) => {
			const tempQuestionObj = {
				question: jq.question,
				questionChinese: jq.questionChinese,
				questionMalay: jq.questionMalay,
				isTemplate: jq.isTemplate,
				questionType: jq.questionType,
			}
			if (jq.questionType === 'MCQ') {
				tempQuestionObj.maxAnswer = jq.maxAnswer
			}
			if (jq.questionType !== 'OPENENDED') {
				tempQuestionObj.Answers = {
					data: jq.Answers.map((ja) => {
						return {
							answer: ja.answer,
							answerChinese: ja.answerChinese,
							answerMalay: ja.answerMalay,
							sequence: ja.sequence,
						}
					}),
				}
			}
			if (jq.isTemplate && jq.id) {
				return {
					question: jq.id,
					sequence: i + 1,
				}
			} else {
				return {
					Question: {
						data: tempQuestionObj,
					},
					sequence: i + 1,
				}
			}
		})
	}

	// console.log(values)
	const branchesSelected = currentUserBranches[0].selectedBranches
	const mrtStationsSelected = currentUserBranches[0].selectedMrtStations
	const citiesSelected = currentUserBranches[0].selectedCities

	if (
		branchesSelected.length > 0 ||
    mrtStationsSelected.length > 0 ||
    citiesSelected.length > 0
	) {
		// return an arr of newly selected Branch(es) / mrtStation
		const jobLocationObj = () => {
			const newBranchArr = branchesSelected
				.filter((branch) => !branchIds.includes(branch))
				.map((branch) => {
					return { branch }
				})

			const newMRTStationArr = mrtStationsSelected
				.filter((station) => !mrtStationIds.includes(station))
				.map((mrtStation) => {
					return { mrtStation }
				})

			const newCityArr = citiesSelected
				.filter((city) => !cityIds.includes(city))
				.map((cityId) => {
					return { cityId }
				})

			return newBranchArr.concat(newMRTStationArr).concat(newCityArr)
		}

		//   // Branch(es) unchecked (delete)
		const jobLocationIds = () => {
			// return Branch / MrtStation's Id [1, 2]
			const uncheckedBranches = branchIds.filter(
				(location) => !branchesSelected.includes(location)
			)
			const uncheckedMrtStations = mrtStationIds.filter(
				(station) => !mrtStationsSelected.includes(station)
			)
			const uncheckedCities = cityIds.filter(
				(id) => !citiesSelected.includes(id)
			)
			// return arr of Ids from Branch / MrtStation Respectively
			const uncheckedBranchIds = uncheckedBranches
			// eslint-disable-next-line
        .map((branch) =>
					workingLocations.find((location) => {
						if (location.Branch && location.Branch.id === branch) {
							return location.Branch.id
						}
					})
				)
				.map((jobLocation) => jobLocation.id)
			const uncheckedMRTStationIds = uncheckedMrtStations
			// eslint-disable-next-line
        .map((station) =>
					workingLocations.find((location) => {
						if (location.mrtStation && location.mrtStation === station) {
							return location.mrtStation
						}
					})
				)
				.map((jobLocation) => jobLocation.id)
			const uncheckedCityIds = uncheckedCities
			// eslint-disable-next-line
        .map((city) =>
					workingLocations.find((location) => {
						if (location.cityId && location.cityId === city) {
							return location.cityId
						}
					})
				)
				.map((jobLocation) => jobLocation.id)

			return uncheckedBranchIds
				.concat(uncheckedMRTStationIds)
				.concat(uncheckedCityIds)
		}

		const jobHashtagObj = () =>
			values.hashtags.map((ht) => {
				return { job: jobId, hashtag: ht }
			})

		const oldJobHashtagIds = () =>
			currentHashtags.map((cht) => {
				return cht.id
			})

		// console.log(oldJobHashtagIds)
		// return false
		const jobObjects = () => {
			const tempObj = {
				companyId: companyId,
				title: values.title,
				description: values.description,
				requirements: values.requirements,
				id: jobId,
				isAvailable: !values.event,
				// Always current timestamp
				jobPostStart: moment().format(),
				jobPostEnd: values.jobPostEndDate.format(),
				jobPostType: '',
				JobLocations: { data: jobLocationObj() },
				jobOccupation: values.category,
				jobOccupationOthers: values.categoryText ? values.categoryText : null,
				minimumEducation: values.minimumEducation
					? values.minimumEducation
					: null,
			}

			if (values.specialization) {
				tempObj.jobCategory = values.specialization
			}

			tempObj.eventID =
        typeof values.event !== 'undefined' ? values.event : null

			if (tempObj.eventID) {
				const selectedEvent = jobEvents.filter(
					(je) => parseInt(tempObj.eventID) === je.id
				)
				if (selectedEvent.length > 0) {
					tempObj.jobPostEnd = selectedEvent[0].endDate
					tempObj.jobGroupType = selectedEvent[0].jobGroupType
				}

				// tempObj.JobPlatforms = { data: { platform: 'VCF' } }
			}
			// else {
			//   tempObj.JobPlatforms = { data: { platform: currentUserBranches[0].platform } }
			// }
			tempObj.isRequiredICMS = currentUserBranches[0].platform === 'NTUC'

			if (values.jobType.indexOf('en') !== -1) {
				tempObj.title = values.title
				tempObj.description = values.description
				tempObj.requirements = values.requirements
				tempObj.jobPostType += 'EN'
			}

			if (values.jobType.indexOf('cn') !== -1) {
				tempObj.titleChinese = values.titleCn
				tempObj.descriptionChinese = values.descriptionCn
				tempObj.requirementsChinese = values.requirementsCn
				if (tempObj.jobPostType === '') {
					tempObj.title = values.titleCn
					tempObj.description = values.descriptionCn
					tempObj.requirements = values.requirementsCn
				}
				tempObj.jobPostType += 'CN'
			}

			if (values.jobType.indexOf('my') !== -1) {
				tempObj.titleMalay = values.titleMy
				tempObj.descriptionMalay = values.descriptionMy
				tempObj.requirementsMalay = values.requirementsMy
				if (tempObj.jobPostType === '') {
					tempObj.title = values.titleMy
					tempObj.description = values.descriptionMy
					tempObj.requirements = values.requirementsMy
				}
				tempObj.jobPostType += 'MY'
			}

			if (haveQuestion) {
				tempObj.JobQuestions = {
					data: jobQuestionObjects,
				}
			}
			return tempObj
		}

		// for insert_JobSalary's var
		const jobSalaryObjects = () => {
			const jobSalaryArr = []

			// for checking if it's a existing row in JobSalary
			const isExistingRecord = (jobType) => {
				// return boolean
				return jobSalaries.some((Salary) => Salary.jobType === jobType)
			}

			const getJobSalaryId = (jobType) => {
				// return the corresponding obj
				const correspondingObj = jobSalaries.find(
					(salary) => salary.jobType === jobType
				)
				return correspondingObj.id
			}

			// isEmploymentType contains the checked options from User
			if (isEmploymentType.FT) {
				const jobSalaryObj = {
					job: jobId,
					jobType: 'FT',
					max: parseInt(values.maxSalaryFT),
					min: parseInt(values.minSalaryFT),
					salaryType: 'PER MONTH',
				}
				if (isExistingRecord('FT')) {
					jobSalaryObj.id = getJobSalaryId('FT')
				}
				jobSalaryArr.push(jobSalaryObj)
			}
			if (isEmploymentType.PT) {
				const jobSalaryObj = {
					job: jobId,
					jobType: 'PT',
					max: parseInt(values.maxSalaryPT),
					min: parseInt(values.minSalaryPT),
					salaryType: values.salaryTypePT,
				}
				if (isExistingRecord('PT')) {
					jobSalaryObj.id = getJobSalaryId('PT')
				}
				jobSalaryArr.push(jobSalaryObj)
			}
			if (isEmploymentType.CONTRACT) {
				const jobSalaryObj = {
					job: jobId,
					jobType: 'CONTRACT',
					max: parseInt(values.maxSalaryContract),
					min: parseInt(values.minSalaryContract),
					salaryType: values.salaryTypeContract,
				}
				if (isExistingRecord('CONTRACT')) {
					jobSalaryObj.id = getJobSalaryId('CONTRACT')
				}
				jobSalaryArr.push(jobSalaryObj)
			}
			return jobSalaryArr
		}

		// for delete_JobSalary
		const jobSalaryIds = () => {
			// arr stores the checked Employment Type(s)
			const checkedEmploymentTypes = _.keys(_.pickBy(isEmploymentType))

			// existing record(s)
			// eslint-disable-next-line
      const uncheckedJobSalaries = jobSalaries.filter((salary) => {
				if (!checkedEmploymentTypes.includes(salary.jobType)) return salary
			})

			const deleteSalaryVar = uncheckedJobSalaries.map((salary) => salary.id)

			return deleteSalaryVar
		}

		const getJobPlatformObj = () => {
			// console.log(values.event)
			// let string
			const arr = []

			if (values.event) arr.push({ platform: 'VCF', job: jobId })
			else {
				if (currentUserBranches[0].platform === 'NTUC') {
					arr.push({ platform: 'NTUC', job: jobId })
					arr.push({ platform: 'REGULAR', job: jobId })
				} else {
					arr.push({ platform: currentUserBranches[0].platform, job: jobId })
				}
			}

			return arr
		}

		const updateJobQuery = gql`
      mutation (
        $jobObjects: [Job_insert_input!]!
        $jobSalaryObjects: [JobSalary_insert_input!]!
        $jobLocationIds: [Int!]
        $jobSalaryIds: [Int!]
        $jobHashtagObj: [JobHashTag_insert_input!]!
        $oldJobHashtagIds: [Int!]
        $jobPlatformObj: [JobPlatform_insert_input!]!
        $jobId: Int!
      ) {
        # delete_JobPlatform(where: {
        # job: {_eq: $jobId}
        # platform: {_in: ["REGULAR", "VCF", “NTUC”, "WESTCOAST"]}
        # }) { affected_rows}

        insert_Job(
          objects: $jobObjects
          on_conflict: {
            constraint: Job_pkey
            update_columns: [
              description
              descriptionChinese
              jobPostStart
              jobPostEnd
              jobPostType
              requirements
              requirementsChinese
              title
              titleChinese
              jobOccupation
              jobOccupationOthers
              titleMalay
              descriptionMalay
              requirementsMalay
              eventID
              isAvailable
              jobCategory
              isRequiredICMS
              minimumEducation
            ]
          }
        ) {
          affected_rows
        }
        insert_JobSalary(
          objects: $jobSalaryObjects
          on_conflict: {
            constraint: JobSalary_id_key
            update_columns: [max, min, salaryType]
          }
        ) {
          affected_rows
        }
        delete_JobLocation(where: { id: { _in: $jobLocationIds } }) {
          affected_rows
        }
        delete_JobSalary(where: { id: { _in: $jobSalaryIds } }) {
          affected_rows
        }
        delete_JobHashTag(where: { id: { _in: $oldJobHashtagIds } }) {
          affected_rows
        }
        insert_JobHashTag(objects: $jobHashtagObj) {
          affected_rows
        }
        insert_JobPlatform(
          objects: $jobPlatformObj
          on_conflict: {
            constraint: JobPlatform_job_platform_key
            update_columns: []
          }
        ) {
          affected_rows
        }
      }
    `

		const updateQueryOptions = {
			mutation: updateJobQuery,
			variables: {
				jobObjects: jobObjects(),
				jobSalaryObjects: jobSalaryObjects(),
				jobLocationIds: jobLocationIds(),
				jobSalaryIds: jobSalaryIds(),
				jobPlatformObj: getJobPlatformObj(),
				jobId,
			},
		}
		
		updateQueryOptions.variables.jobHashtagObj = jobHashtagObj()
		updateQueryOptions.variables.oldJobHashtagIds = oldJobHashtagIds()

		// console.log(updateQueryOptions)
		
		Client.mutate({
			mutation: gql`mutation ($currentJobQuestion: [Int!]) {
			    update_JobQuestion(where: {id: {_in: $currentJobQuestion}}, _set: {deletedAt: "${new Date(
		Date.now()
	).toISOString()}", deletedBy: null}) {
			      affected_rows
			    }
			  }`,
			variables: {
				currentJobQuestion: currentJobQuestion,
			},
		}).then(() => {
			Client.mutate(updateQueryOptions).then((jobMutationRes) => {
				const { data } = jobMutationRes
				const affectedRows = data.insert_Job.affected_rows
				if (affectedRows) {
					// redirect to Job?
					navigate(-1)
					message.success('Job Successfully Edited')
				}
			})
		})
	} else {
		message.warning(
			'Please select at least one branch and/or MRT Station/City as the working location for each company selected'
		)
	}
}

const handleOnFinishFailed = ({ values, errorFields, outOfDate }) => {
	if (errorFields && errorFields.length) {
		const errorMessages = errorFields.map((error) => {
			const message = error.errors.filter((a) => a).toString()
			return message
		})
		const messageNode = (
			<>
				{errorMessages.map((msg, index) => {
					return <div key={index}>{msg}</div>
				})}
			</>
		)
		return message.error(messageNode)
	}
}

export default {
	initCreateJob,
	initEditJob,
	handleOnSubmitCreate,
	handleOnSubmitUpdate,
	handleOnFinishFailed,
}
